import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { StoreContext } from 'store/context'

import SignupComponent from './component'

export default combine(
  withContext('auth', StoreContext, ({ auth }) => auth),
  withCallbacks(
    {
      onSubmit:
        ({ auth }) =>
        (registrationData) =>
          auth.register(registrationData),
    },
    []
  )
)(SignupComponent)
